// extracted by mini-css-extract-plugin
module.exports = {"social":"styles_social__2KeP9","item":"styles_item__UaCGW","icon-vk":"styles_icon-vk__3uWZD"};